export default "__VITE_ASSET__y9iju2In__"